<template>
  <Transition name="fade-fast">
    <button
      v-if="visible"
      type="button"
      class="button__return --fixed --scroll-top"
      @click.prevent="scrollTop"
    >
      <Icon id="arrow" />
    </button>
  </Transition>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'ScrollTopButton',
  components: {
    Icon,
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    scrollTop() {
      this.$nextTick(() => {
        window.scrollTo({ behavior: 'smooth', top: 0 })
      })
    },
    updateVisibility() {
      this.visible = window.scrollY > 20
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateVisibility)
  },
  unmounted() {
    window.removeEventListener('scroll', this.updateVisibility)
  },
}
</script>
